import React from 'react';

const Logo = () => {
  return (
    <div className="w-full flex justify-center mb-8">
      <img src="/images/logo.png" alt="Letter Atlas" className="w-16 h-16" />
    </div>
  );
};

export default Logo; 